import React from "react";

const rankClass = { 1: "rank-1", 2: "rank-2", 3: "rank-3" };

const VesselRankList = ({ vessels = [] }) => (
  <div className="frm-card">
    {vessels.map(v => (
      <div key={v.rank} className="vrl-item">
        <div className={`vrl-rank ${rankClass[v.rank] || ""}`}>{v.rank}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="vrl-name">{v.name}</div>
          <div className="vrl-desc">{v.desc}</div>
          <div className="vrl-meta"><span>{v.location}</span><span>{v.date}</span></div>
        </div>
        <div className="vrl-cost">{v.cost}</div>
      </div>
    ))}
  </div>
);
export default VesselRankList;